import React, { useState } from "react";

export default function AppIcon({ app, large = false }) {
  const [imageFailed, setImageFailed] = useState(false);
  const icon = app?.displayIcon || app?.iconUrl || null;
  if (icon && !imageFailed) return (
    <img className={`uas-app-icon ${large ? "uas-app-icon--large" : ""}`}
      src={icon} onError={() => setImageFailed(true)} alt={`${app.name} icon`} />
  );
  const initials = (app?.shortName || app?.name || "U").split(/\s+/)
    .map((part) => part[0]).join("").slice(0, 4).toUpperCase();
  return <div className={`uas-app-icon uas-app-icon--fallback ${large ? "uas-app-icon--large" : ""}`}
    aria-hidden="true">{initials}</div>;
}
